var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"text-blue-600 underline text-sm cursor-pointer",on:{"click":_vm.resetQuery}},[_vm._v("Un filtre est actif, cliquez ici pour le supprimer")])])
}
var staticRenderFns = []

export { render, staticRenderFns }